import { zExt } from "@redotech/redo-model/common/zod-util";
import { giftReceiptSchema } from "@redotech/redo-model/gift-receipt/gift-receipt";
import { z } from "zod/v4";

export enum GetGiftReceiptErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  NOT_FOUND = "NOT FOUND",
  COULD_NOT_PARSE = "COULD NOT PARSE",
}

export const getGiftReceipt = {
  name: "getGiftReceipt" as const,
  input: z.object({ giftReceiptId: zExt.objectId() }),
  output: z.object({ giftReceipt: giftReceiptSchema, link: z.string() }),
};
